import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  LIST_getInstance2leq5bbahk4rz as LIST_getInstance,
  MAP_getInstance141vh6u7faopd as MAP_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetClassDescClass;
function LinkedHashSetClassDesc() {
  if (LinkedHashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      d1o() {
        return 'kotlin.collections.LinkedHashSet';
      }
    }
    initMetadataForClass($, 'LinkedHashSetClassDesc');
    LinkedHashSetClassDescClass = $;
  }
  return LinkedHashSetClassDescClass;
}
var ArrayListClassDescClass;
function ArrayListClassDesc() {
  if (ArrayListClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      d1o() {
        return 'kotlin.collections.ArrayList';
      }
    }
    initMetadataForClass($, 'ArrayListClassDesc');
    ArrayListClassDescClass = $;
  }
  return ArrayListClassDescClass;
}
var HashSetClassDescClass;
function HashSetClassDesc() {
  if (HashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      d1o() {
        return 'kotlin.collections.HashSet';
      }
    }
    initMetadataForClass($, 'HashSetClassDesc');
    HashSetClassDescClass = $;
  }
  return HashSetClassDescClass;
}
var HashMapClassDescClass;
function HashMapClassDesc() {
  if (HashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.HashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'HashMapClassDesc');
    HashMapClassDescClass = $;
  }
  return HashMapClassDescClass;
}
var LinkedHashMapClassDescClass;
function LinkedHashMapClassDesc() {
  if (LinkedHashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'LinkedHashMapClassDesc');
    LinkedHashMapClassDescClass = $;
  }
  return LinkedHashMapClassDescClass;
}
var ArrayClassDescClass;
function ArrayClassDesc() {
  if (ArrayClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      d1o() {
        return 'kotlin.Array';
      }
    }
    initMetadataForClass($, 'ArrayClassDesc');
    ArrayClassDescClass = $;
  }
  return ArrayClassDescClass;
}
var ListLikeDescriptorClass;
function ListLikeDescriptor() {
  if (ListLikeDescriptorClass === VOID) {
    class $ {
      constructor(elementDescriptor) {
        this.d1u_1 = elementDescriptor;
        this.e1u_1 = 1;
      }
      w1p() {
        return LIST_getInstance();
      }
      y1p() {
        return this.e1u_1;
      }
      a1q(index) {
        return index.toString();
      }
      b1q(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().n2(name + ' is not a valid list index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      e1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return false;
      }
      c1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return emptyList();
      }
      d1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.d1u_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListLikeDescriptor()))
          return false;
        if (equals(this.d1u_1, other.d1u_1) && this.d1o() === other.d1o())
          return true;
        return false;
      }
      hashCode() {
        return imul(hashCode(this.d1u_1), 31) + getStringHashCode(this.d1o()) | 0;
      }
      toString() {
        return this.d1o() + '(' + toString(this.d1u_1) + ')';
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    protoOf($).z1p = get_annotations;
    initMetadataForClass($, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    ListLikeDescriptorClass = $;
  }
  return ListLikeDescriptorClass;
}
var MapLikeDescriptorClass;
function MapLikeDescriptor() {
  if (MapLikeDescriptorClass === VOID) {
    class $ {
      constructor(serialName, keyDescriptor, valueDescriptor) {
        this.j1u_1 = serialName;
        this.k1u_1 = keyDescriptor;
        this.l1u_1 = valueDescriptor;
        this.m1u_1 = 2;
      }
      d1o() {
        return this.j1u_1;
      }
      w1p() {
        return MAP_getInstance();
      }
      y1p() {
        return this.m1u_1;
      }
      a1q(index) {
        return index.toString();
      }
      b1q(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().n2(name + ' is not a valid map index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      e1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return false;
      }
      c1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return emptyList();
      }
      d1q(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.d1o() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        var tmp;
        switch (index % 2 | 0) {
          case 0:
            tmp = this.k1u_1;
            break;
          case 1:
            tmp = this.l1u_1;
            break;
          default:
            // Inline function 'kotlin.error' call

            var message_0 = 'Unreached';
            throw IllegalStateException().o(toString(message_0));
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapLikeDescriptor()))
          return false;
        if (!(this.d1o() === other.d1o()))
          return false;
        if (!equals(this.k1u_1, other.k1u_1))
          return false;
        if (!equals(this.l1u_1, other.l1u_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getStringHashCode(this.d1o());
        result = imul(31, result) + hashCode(this.k1u_1) | 0;
        result = imul(31, result) + hashCode(this.l1u_1) | 0;
        return result;
      }
      toString() {
        return this.d1o() + '(' + toString(this.k1u_1) + ', ' + toString(this.l1u_1) + ')';
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    protoOf($).z1p = get_annotations;
    initMetadataForClass($, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    MapLikeDescriptorClass = $;
  }
  return MapLikeDescriptorClass;
}
var PrimitiveArrayDescriptorClass;
function PrimitiveArrayDescriptor() {
  if (PrimitiveArrayDescriptorClass === VOID) {
    class $ extends ListLikeDescriptor() {
      constructor(primitive) {
        super(primitive);
        this.r1u_1 = primitive.d1o() + 'Array';
      }
      d1o() {
        return this.r1u_1;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayDescriptor');
    PrimitiveArrayDescriptorClass = $;
  }
  return PrimitiveArrayDescriptorClass;
}
//region block: exports
export {
  ArrayClassDesc as ArrayClassDesc2voesact8ugbc,
  ArrayListClassDesc as ArrayListClassDesc2euexqfjnihq7,
  HashMapClassDesc as HashMapClassDesc33bep136pd9y6,
  HashSetClassDesc as HashSetClassDesc1sva99tssxbb4,
  LinkedHashMapClassDesc as LinkedHashMapClassDesc1yxtovbec4ruk,
  LinkedHashSetClassDesc as LinkedHashSetClassDesc202cqq5740j6e,
  PrimitiveArrayDescriptor as PrimitiveArrayDescriptor3bvg9e2uulc3b,
};
//endregion

//# sourceMappingURL=CollectionDescriptors.mjs.map
